import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-70fe4224")

_pushScopeId("data-v-70fe4224")
const _hoisted_1 = { class: "entry-record" }
const _hoisted_2 = { class: "record-photo" }
const _hoisted_3 = { class: "custom-image-error" }
const _hoisted_4 = { class: "record-msg" }
const _hoisted_5 = { class: "time" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_el_image = _resolveComponent("el-image")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_el_image, {
        src: _ctx.recordData.CachedPicUrl,
        "preview-src-list": [_ctx.recordData.CachedPicUrl],
        "preview-teleported": true,
        class: "record-img"
      }, {
        error: _withId(() => [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_svg_icon, {
              name: "icon-error",
              color: "#a8abb2",
              fontSize: "20px"
            })
          ])
        ]),
        _: 1
      }, 8, ["src", "preview-src-list"])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("p", {
        class: "name",
        title: _ctx.recordData.Initiator
      }, _toDisplayString(_ctx.recordData.Initiator), 9, ["title"]),
      _createVNode("text", {
        class: "device",
        title: _ctx.recordData.Location
      }, _toDisplayString(_ctx.recordData.Location), 9, ["title"]),
      _createVNode("p", _hoisted_5, _toDisplayString(_ctx.dayjsFormat(_ctx.recordData.CaptureTime, _ctx.timeFormatMap[Number(_ctx.community.customizeForm.value) as keyof typeof _ctx.timeFormatMap])), 1)
    ])
  ]))
})